import React from "react";

const XCircle = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-x-circle"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-x-circle"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm4.765,16.105c.356.423.302,1.054-.12,1.409-.188.158-.417.235-.644.235-.285,0-.568-.121-.766-.355l-3.235-3.842-3.235,3.842c-.197.234-.48.355-.766.355-.227,0-.456-.077-.644-.235-.422-.355-.477-.986-.12-1.409l3.457-4.105-3.457-4.105c-.356-.423-.302-1.054.12-1.409.423-.357,1.055-.301,1.409.12l3.235,3.842,3.235-3.842c.354-.42.986-.477,1.409-.12.422.355.477.986.12,1.409l-3.457,4.105,3.457,4.105Z" />
    </svg>
  );
};

export default XCircle;
